import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import {Row, Column} from '../../global/grid/grid';

import { VideoPlayer } from './styled-components';

@inject("store")
@observer class Video extends Component {
    constructor(props) {
        super(props);

        this.state = {
            playing: false
        }

        this.video = null;
        this.handleClick = this.handleClick.bind(this);
        this.videoEnded = this.videoEnded.bind(this);
        this.onTimeUpdate = this.onTimeUpdate.bind(this);

        this.quarterComplete = false;
        this.halfComplete = false;
        this.threeQuartersComplete = false;
    }
    componentDidMount() {
        const { store } = this.props;
        this.video.addEventListener('ended', this.videoEnded);
        if(store.os.name === 'ios') {
            setTimeout(() => {
                const playPromise = this.video.play();
                if (playPromise !== undefined) {
                playPromise.then(() => {
                    this.video.pause();
                    }).catch((error) => {
                        // Automatic playback failed.
                        // Show a UI element to let the user manually start playback.
                    });
                } else {
                    this.video.pause();
                }
            }, 1);
        }
    }
    componentWillUnmount() {
        this.video.removeEventListener('ended', this.videoEnded);
    }
    videoEnded() {
        const { srcMp4, srcWebM } = this.props;
        this.setState({
            playing: false
        });
        window.dataLayer.push({
            'event': 'video:complete',
            /* 'videoName': '<name of video>', */
            'videoLength': this.video.duration,
            'videoLocation': srcMp4
        });
    }
    handleClick() {
        const { srcMp4, srcWebM } = this.props;
        if(this.video.paused || this.video.ended) {
            // console.log('bing');
            this.video.play();
            this.setState({
                playing: true
            });
            window.dataLayer.push({
                'event': 'video:play',
                /* 'videoName': '<name of video>', */
                'videoLength': this.video.duration,
                'videoLocation': srcMp4
            });
        } else {
            this.video.pause();
            this.setState({
                playing: false
            });
            window.dataLayer.push({
                'event': 'video:pause',
                /* 'videoName': '<name of video>', */
                'videoLength': this.video.duration,
                'videoLocation': srcMp4
            });
        }
    }
    onTimeUpdate(e) {
        const { srcMp4, srcWebM } = this.props;
        const videoFrame = Math.round(e.target.currentTime);
        const videoProgress = videoFrame / this.video.duration;
        if(videoProgress > 0.25 && videoProgress < 0.5) {
            if(!this.quarterComplete) {
                window.dataLayer.push({
                    'event': 'video:progress',
                    'videoCompletion': '25',
                    'videoDuration': this.video.duration,
                    'videoLocation': srcMp4
                });
                this.quarterComplete = true;
            }
        } else if(videoProgress > 0.5 && videoProgress < 0.75) {
            if(!this.halfComplete) {
                window.dataLayer.push({
                    'event': 'video:progress',
                    'videoCompletion': '50',
                    'videoDuration': this.video.duration,
                    'videoLocation': srcMp4
                });
                this.halfComplete = true;
            }
        } else if(videoProgress > 0.75 && videoProgress < 1) {
            if(!this.threeQuartersComplete) {
                window.dataLayer.push({
                    'event': 'video:progress',
                    'videoCompletion': '75',
                    'videoDuration': this.video.duration,
                    'videoLocation': srcMp4
                });
                this.threeQuartersComplete = true;
            }
        } else {
            this.quarterComplete = false;
            this.halfComplete = false;
            this.threeQuartersComplete = false;
        }
    }
    render() {
        const { srcMp4, srcWebM, tall } = this.props;
        if(!tall) {
            return (
                <VideoPlayer>
                    <div style={{width: '100%', paddingBottom: 'calc((9/16) * 100%)'}}></div>
                    <video
                    ref={(video) => { this.video = video }}
                    width="100%"
                    height="auto"
                    playsInline="true"
                    onTimeUpdate={this.onTimeUpdate}
                    style={{
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        right: 0,
                        left: 0
                    }}
                    >
                        <source src={srcWebM} type="video/webm" />
                        <source src={srcMp4} type="video/mp4" />
                    </video>
                    <div
                    onClick={this.handleClick}
                    className={`ui-holder ${this.state.playing ? 'playing' : ''}`}
                    style={{
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        right: 0,
                        left: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    >
                        <div
                        className="ui-button"
                        style={{
                            height: '120px',
                            width: '120px',
                            boxSizing: 'border-box',
                            borderRadius: '60px',
                            border: 'solid 5px white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                        }}>
                            { this.state.playing === false &&
                                <svg width="34px" height="31px" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                    <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                        <g id="dominos-casestudy-desktop" transform="translate(-709.000000, -523.000000)" fill="#FFFFFF">
                                            <g id="Hero">
                                                <g id="Video" transform="translate(200.000000, 197.000000)">
                                                    <g id="ICON" transform="translate(459.000000, -127.000000)">
                                                        <g id="PLAY-ICON" transform="translate(8.000000, 407.000000)">
                                                            <polygon id="Triangle" points="75 61.5 50 77 50 46"></polygon>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            }
                            { this.state.playing &&
                                <svg width="34px" height="31px" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                    <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                        <g id="dominos-casestudy-desktop" transform="translate(-709.000000, -523.000000)" fill="#FFFFFF">
                                            <g id="Hero">
                                                <g id="Video" transform="translate(200.000000, 197.000000)">
                                                    <g id="ICON" transform="translate(459.000000, -127.000000)">
                                                        <g id="PLAY-ICON" transform="translate(5.000000, 407.000000)">
                                                            <rect width="10" height="40" x="50" y="46" />
                                                            <rect width="10" height="40" x="65" y="46" />
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            }
                        </div>
                    </div>
                </VideoPlayer>
            )
        } else {
            return (
                <VideoPlayer>
                    <div style={{width: '100%', paddingTop: 'calc((10/7) * 100%)'}}></div>
                    <video
                    ref={(video) => { this.video = video }}
                    width="auto"
                    height="100%"
                    playsInline="true"
                    onTimeUpdate={this.onTimeUpdate}
                    style={{
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        right: 0,
                        left: '-50%'
                    }}
                    >
                        <source src={srcWebM} type="video/webm" />
                        <source src={srcMp4} type="video/mp4" />
                    </video>
                    <div
                    onClick={this.handleClick}
                    className={`ui-holder ${this.state.playing ? 'playing' : ''}`}
                    style={{
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        right: 0,
                        left: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    >
                        <div
                        className="ui-button"
                        style={{
                            height: '120px',
                            width: '120px',
                            boxSizing: 'border-box',
                            borderRadius: '60px',
                            border: 'solid 5px white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                        }}>
                            { this.state.playing === false &&
                                <svg width="34px" height="31px" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                    <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                        <g id="dominos-casestudy-desktop" transform="translate(-709.000000, -523.000000)" fill="#FFFFFF">
                                            <g id="Hero">
                                                <g id="Video" transform="translate(200.000000, 197.000000)">
                                                    <g id="ICON" transform="translate(459.000000, -127.000000)">
                                                        <g id="PLAY-ICON" transform="translate(8.000000, 407.000000)">
                                                            <polygon id="Triangle" points="75 61.5 50 77 50 46"></polygon>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            }
                            { this.state.playing &&
                                <svg width="34px" height="31px" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                    <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                        <g id="dominos-casestudy-desktop" transform="translate(-709.000000, -523.000000)" fill="#FFFFFF">
                                            <g id="Hero">
                                                <g id="Video" transform="translate(200.000000, 197.000000)">
                                                    <g id="ICON" transform="translate(459.000000, -127.000000)">
                                                        <g id="PLAY-ICON" transform="translate(5.000000, 407.000000)">
                                                            <rect width="10" height="40" x="50" y="46" />
                                                            <rect width="10" height="40" x="65" y="46" />
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            }
                        </div>
                    </div>
                </VideoPlayer>
            )
        }
    }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/global/media/Video.js